import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'words' })
export class WordsPipe implements PipeTransform {
  public transform(input: string, wordCount?: number): string {
    if (!input) return ''
    const words = input.toString().trim().split(/\s+/g)
    const count = wordCount || words.length
    const ellipsis = (words.length > count) ? '…' : ''
    const truncated = words.slice(0, count).join(' ')
    const stripped = ellipsis ? truncated.replace(/[^\w]$/, '') : truncated
    return `${stripped}${ellipsis}`
  }
}
